var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsString, IsNumber, IsBoolean, IsOptional, ValidateNested, IsDate } from "class-validator";
import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
export var MergeType;
(function (MergeType) {
    MergeType["TRIVIAL"] = "TRIVIAL";
    MergeType["NON_TRIVIAL"] = "NON_TRIVIAL";
})(MergeType || (MergeType = {}));
export class AccountSummaryDto {
}
__decorate([
    ApiProperty({ description: "Patient ID" }),
    IsString()
], AccountSummaryDto.prototype, "patientId", void 0);
__decorate([
    ApiPropertyOptional({ description: "Patient email" }),
    IsString(),
    IsOptional()
], AccountSummaryDto.prototype, "email", void 0);
__decorate([
    ApiProperty({ description: "Number of finalized health record retrievals" }),
    IsNumber()
], AccountSummaryDto.prototype, "retrievalCount", void 0);
__decorate([
    ApiPropertyOptional({ description: "Last activity timestamp" }),
    Type(() => Date),
    IsDate(),
    IsOptional()
], AccountSummaryDto.prototype, "lastActiveAt", void 0);
__decorate([
    ApiProperty({ description: "Whether this account has CLEAR authentication" }),
    IsBoolean()
], AccountSummaryDto.prototype, "hasClearAuth", void 0);
export class AccountLinkingConflictDto {
}
__decorate([
    ApiProperty({ description: "Signed token to switch to the CLEAR account (only used if user chooses CLEAR)" }),
    IsString()
], AccountLinkingConflictDto.prototype, "accountSwitchToken", void 0);
__decorate([
    ApiProperty({ description: "Existing account (currently logged in via social login)" }),
    ValidateNested(),
    Type(() => AccountSummaryDto)
], AccountLinkingConflictDto.prototype, "existingAccount", void 0);
__decorate([
    ApiProperty({ description: "CLEAR account (from CLEAR authentication)" }),
    ValidateNested(),
    Type(() => AccountSummaryDto)
], AccountLinkingConflictDto.prototype, "clearAccount", void 0);
export class SwitchAccountInput {
}
__decorate([
    ApiProperty({ description: "Signed token from conflict detection" }),
    IsString()
], SwitchAccountInput.prototype, "accountSwitchToken", void 0);
export var PatientEmailSource;
(function (PatientEmailSource) {
    PatientEmailSource["CLEAR"] = "CLEAR";
    PatientEmailSource["GOOGLE"] = "GOOGLE";
    PatientEmailSource["MICROSOFT"] = "MICROSOFT";
    PatientEmailSource["APPLE"] = "APPLE";
    PatientEmailSource["MERGE"] = "MERGE";
    PatientEmailSource["MIGRATION"] = "MIGRATION";
})(PatientEmailSource || (PatientEmailSource = {}));
export class PatientEmailDto {
}
__decorate([
    ApiProperty(),
    IsString()
], PatientEmailDto.prototype, "id", void 0);
__decorate([
    ApiProperty(),
    IsString()
], PatientEmailDto.prototype, "email", void 0);
__decorate([
    ApiProperty(),
    IsBoolean()
], PatientEmailDto.prototype, "isPrimary", void 0);
__decorate([
    ApiProperty({ enum: PatientEmailSource }),
    IsString()
], PatientEmailDto.prototype, "source", void 0);
export class PatientPhoneDto {
}
__decorate([
    ApiProperty(),
    IsString()
], PatientPhoneDto.prototype, "id", void 0);
__decorate([
    ApiProperty(),
    IsString()
], PatientPhoneDto.prototype, "phoneNumber", void 0);
__decorate([
    ApiProperty(),
    IsBoolean()
], PatientPhoneDto.prototype, "isPrimary", void 0);
